import {
  sourceLanguage,
  supportedLanguages,
  type SupportedLanguage,
} from './resources';

export const languageStorageKey = 'trio-waiter:language';

export const getStartupLanguage = (): SupportedLanguage => {
  let preferredLanguage: string | null = null;
  try {
    preferredLanguage = localStorage.getItem(languageStorageKey);
  } catch {
    // Language selection remains available when browser storage is blocked.
  }
  const language = (preferredLanguage ?? navigator.language).split('-')[0];
  return (
    supportedLanguages.find((candidate) => candidate === language) ??
    sourceLanguage
  );
};

export const saveStartupLanguage = (language: SupportedLanguage): void => {
  try {
    localStorage.setItem(languageStorageKey, language);
  } catch {
    // This page can still use the selected language without persistence.
  }
};
